import React, { forwardRef, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';

const BOTTOM_THRESHOLD = 20;

const Scrollbar = forwardRef(({ children, onYReachEnd, onScrollUp, style, ...other }, ref) => {
    const prevScrollTop = useRef(0);

    const handleScroll = useCallback((e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

        if (onScrollUp && scrollTop < prevScrollTop.current) {
            onScrollUp(e.currentTarget);
        }

        if (onYReachEnd && scrollHeight - scrollTop - clientHeight <= BOTTOM_THRESHOLD) {
            onYReachEnd();
        }

        prevScrollTop.current = scrollTop;
    }, [onYReachEnd, onScrollUp]);

    return (
        <div
            ref={ref}
            onScroll={handleScroll}
            style={{ overflow: 'auto', ...style }}
            {...other}
        >
            {children}
        </div>
    );
});

Scrollbar.propTypes = {
    children: PropTypes.node,
    onYReachEnd: PropTypes.func,
    onScrollUp: PropTypes.func,
    style: PropTypes.object,
};

export default Scrollbar;